<template>
  <!-- 首页 -->
  <div class="main-box">
    <!--    <a class="invest-btn"><i class="iconfont">&#xe618;</i>满意评价</a>-->
    <div class="page-title">
      <div class="line"></div>
      <span><i></i>法律咨询一问就懂</span>
      <div class="line"></div>
    </div>
    <div class="flex-content" style="display: none">
      <div class="consultation">
        <div class="title-box">
          <h3>最新咨询</h3>
          <div class="line"></div>
          <a @click="$router.push('/OnlineConsultation/HistoryCult')">更多+</a>
        </div>
        <div class="scrollbox news">
          <ul class="lastNews">
            <li v-for="(item, index) in consultList" :key="'flfg_' + item.pkid">
              <div class="news">
                <span class="c-red" v-if="index === 0">顶</span>
                <span class="c-blue" v-else>新</span>
                <p class="info-txt wd420">{{ item.title }}</p>
              </div>
              <div class="time">2021-08-19</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="enter-box">
        <div class="enter-item" @click="caseLoginClick('/LegalAidApply')">
          <div class="img-box">
            <img src="@/assets/images/icon1.png" alt="" />
          </div>
          <div class="c-name">法律援助</div>
          <p>Legal</p>
          <p>Aid</p>
        </div>
        <div class="enter-item" @click="caseLoginClick('/LawyerArea')">
          <div class="img-box">
            <img src="@/assets/images/icon2.png" alt="" />
          </div>
          <div class="c-name">律师服务面对面</div>
          <p>Lawyer</p>
          <p>Services</p>
        </div>
        <div class="enter-item" @click="linkToTntellect">
          <div class="img-box">
            <img src="@/assets/images/icon3.png" alt="" />
          </div>
          <div class="c-name">智能法律咨询</div>
          <p>Legal</p>
          <p>Advice</p>
        </div>
        <div class="enter-item" @click="linkToOnline">
          <div class="img-box">
            <img src="@/assets/images/icon4.png" alt="" />
          </div>
          <div class="c-name">在线咨询</div>
          <p>Online</p>
          <p>Consultation</p>
        </div>
      </div>
    </div>

    <div class="consult-list">
      <div class="askitem" @click="caseLoginClick('/LegalAidApply')">
        <div class="icon-box">
          <div class="icon-img">
            <img src="@/assets/images/home-icon1.png" alt="" />
          </div>
          <p>法律援助</p>
        </div>
        <div class="rimg">
          <img src="@/assets/images/home1.png" alt="" />
        </div>
      </div>
      <div class="askitem" @click="caseLoginClick('/LawyerArea')">
        <div class="icon-box">
          <div class="icon-img">
            <img src="@/assets/images/home-icon2.png" alt="" />
          </div>
          <p>律师服务面对面</p>
        </div>
        <div class="rimg">
          <img src="@/assets/images/home2.png" alt="" />
        </div>
      </div>
      <div class="askitem" @click="linkToOnline">
        <div class="icon-box">
          <div class="icon-img">
            <img src="@/assets/images/home-icon3.png" alt="" />
          </div>
          <p>在线咨询</p>
        </div>
        <div class="rimg">
          <img src="@/assets/images/home3.png" alt="" />
        </div>
      </div>
    </div>
    <div class="consult-list">
      <div class="askitem" @click="linkToTntellect">
        <div class="icon-box">
          <div class="icon-img">
            <img src="@/assets/images/home-icon4.png" alt="" />
          </div>
          <p>智能法律咨询</p>
        </div>
        <div class="rimg">
          <img src="@/assets/images/home4.png" alt="" />
        </div>
      </div>
      <div class="askitem" @click="linkToLegalPublicity">
        <div class="icon-box">
          <div class="icon-img">
            <img src="@/assets/images/fzxc.png" alt="" />
          </div>
          <p>法治宣传</p>
        </div>
        <div class="rimg">
          <img src="@/assets/images/fzxc1.png" alt="" />
        </div>
      </div>
      <div class="third">
        <div class="third-title">
          <h3>最新咨询</h3>
          <a @click="$router.push('/OnlineConsultation/HistoryCult')">更多+</a>
        </div>
        <div class="scrollbox list">
          <ul class="listNews">
            <li v-for="(item, index) in consultList" :key="'flfg_' + item.pkid">
              <div
                class="new"
                @click="
                  $router.push({
                    name: 'consultDetail',
                    query: { id: item.pkid },
                  })
                "
              >
                <span class="c-red" v-if="index === 0">顶</span>
                <span class="c-blue" v-else>新</span>
                <p class="info-txt wd420" :title="item.title">{{ item.title }}</p>
              </div>
              <div class="wtime">
                {{ item.create_time ? item.create_time.substring(0, 10) : "" }}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="blue-bg">
      <div class="page-title">
        <div class="line"></div>
        <span><i class="icon-kan"></i>职工维权一看便知</span>
        <div class="line"></div>
      </div>
      <div class="flex-content">
        <div class="consultation">
          <div class="title-box">
            <h3>法律法规</h3>
            <div class="line"></div>
            <a @click="$router.push('/EpRightsProtection')">更多+</a>
          </div>
          <ul class="lastNews">
            <li
              v-for="item in rulelist"
              :key="'flfg_' + item.pkid"
              @click="gotoDocDetail(item)"
            >
              <div class="news">
                <p class="info-txt">{{ item.doc_title }}</p>
              </div>
              <div class="time">{{ item.compose_time }}</div>
            </li>
          </ul>
        </div>
        <div class="consultation">
          <div class="title-box">
            <h3>知识问答</h3>
            <div class="line"></div>
            <a @click="$router.push('/LawsRegulations')">更多+</a>
          </div>
          <ul class="lastNews">
            <li
              v-for="item in answerList"
              :key="'zswd_' + item.pkid"
              @click="gotoDocDetail2(item)"
            >
              <div class="news">
                <p class="info-txt">{{ item.doc_title }}</p>
              </div>
              <div class="time">{{ item.compose_time }}</div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="white-bg">
      <div class="page-title">
        <div class="line"></div>
        <span><i class="icon-zhu"></i>自助服务一用就通</span>
        <div class="line"></div>
      </div>
      <ul class="service-list">
        <li @click="$router.push('/EpRightsProtection')">
          <img src="@/assets/images/li-bg1.png" alt="" />
        </li>
        <!--        <li @click="$router.push('/CaseBase')">-->
        <!--          <img src="@/assets/images/li-bg2.png" alt="" />-->
        <!--        </li>-->
        <li @click="linkToMap">
          <img src="@/assets/images/li-bg3.png" alt="" />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { getDocumentList } from "@/api/document";
import { getHistoryConsultList,getHistoryConsultLists } from "@/api/consult";
import { getSiteIdByDhSiteInfo } from "@/api/grzx";
import { caseLogin } from "../../../public/commonJs.js";

export default {
  name: "FirstHome",
  data() {
    return {
      params: {
        chan_id: 1,
      },
      params1: {
        chan_id: 2,
      },
      culparams: {
        public_indicant: 1,
      },
      rulelist: [],
      answerList: [],
      consultList: [],
    };
  },
  created(){

  },
  mounted() {
    this.getDocumentList();
    this.getHistoryConsultList();

    this.initWebRouter()
  },
  methods: {
    caseLoginClick(url) {

       this.$router.push(url);
    },
    initWebRouter() {
      if (localStorage.getItem("webid") == null) {
        let queryVal = this.$router.currentRoute.query;
        getSiteIdByDhSiteInfo({ pcSiteId: queryVal.webid }).then((res) => {
          localStorage.setItem("webid", res.data.data);
        });
      }
    },
    getDocumentList() {
      let p1 = { chan_id: 1, rows: 5 };
      getDocumentList(p1).then((res) => {
        // console.log(res);
        this.rulelist = res.items;
        return res;
      });
      let p2 = { chan_id: 2, rows: 5 };
      getDocumentList(p2).then((res) => {
        // console.log(res);
        this.answerList = res.items;
        return res;
      });
    },
    gotoDocDetail(item) {
      let routeUrl = this.$router.resolve({
        name: "Regulations1",
        query: { doc_id: item.pkid },
      });
      window.open(routeUrl.href, "_blank");
    },
    gotoDocDetail2(item) {
      let routeUrl = this.$router.resolve({
        name: "Regulations2",
        query: { doc_id: item.pkid },
      });
      window.open(routeUrl.href, "_blank");
    },
    getHistoryConsultList() {
      getHistoryConsultLists(this.culparams).then((res) => {
        this.consultList = res.items;
      });
    },
    gotoConsultDetail(pkid) {
      getHistoryConsultLists(this.culparams).then((res) => {
        this.consultList = res.items;
      });
    },
    linkToTntellect() {
      window.open("https://jszgh.ai.lvpin100.com?userId=951753");
    },
    linkToOnline() {
      /* 判断是否登录 */
      if (caseLogin()) {
        window.open("https://jsgh.ep.laway.cn/");
      }
    },
    linkToMap() {
      window.open("https://www.jsghfw.com/yyczxt/map/mapshowhomepage.do");
    },
    linkToLegalPublicity() {
      this.$router.push({ name: "LegalPublicity" });
    },
  },
};
</script>
<style scoped>
.main-box {
  padding: 20px;
  position: relative;
}

.flex-content {
  display: flex;
  margin-bottom: 40px;
}
.consult-list {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}
.consult-list .consultation {
  margin-left: 20px;
}
.consult-list .consultation .lastNews li {
  line-height: 1;
}
.consult-list .consultation .lastNews li + li {
  margin-top: 20px;
}
.consult-list .consultation .lastNews li:first-child {
  margin-top: 23px;
}
.askitem {
  width: 373px;
  height: 168px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.askitem .icon-box {
  height: 168px;
  width: 134px;
  background: #2680ee;
  text-align: center;
}
.icon-img {
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 37px;
}
.askitem .icon-box p {
  color: #fff;
  font-size: 16px;
  line-height: 1;
  margin: 20px 0 0 0;
}
.blue-bg {
  background: url("~@/assets/images/see-bg.png") no-repeat;
  margin: 20px -20px;
  padding-top: 20px;
  min-height: 287px;
}

.page-title {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.page-title .line {
  height: 10px;
  background: url("~@/assets/images/line.png") repeat-x;
  width: 38.8%;
}

.page-title span {
  font-size: 24px;
  color: #000;
  margin: 0 9px;
  display: flex;
  align-items: center;
}

.page-title span i {
  display: inline-block;
  width: 44px;
  height: 44px;
  background: url("~@/assets/images/icon.png") no-repeat;
  margin-right: 5px;
}

.page-title span i.icon-kan {
  background: url("~@/assets/images/icon-1.png") no-repeat;
}

.page-title span i.icon-zhu {
  background: url("~@/assets/images/icon-2.png") no-repeat;
}

.title-box {
  display: flex;
  align-items: center;
}

.title-box h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0;
}

.title-box .line {
  flex: 1;
  height: 1px;
  background: url("~@/assets/images/sbar.png") repeat;
  margin: 0 7px;
}

.title-box a {
  color: #bbb;
}
.scrollbox.news {
  height: 140px;
  overflow: auto;
  padding-right: 10px;
}
.scrollbox.list {
  height: 140px;
  overflow: auto;
  padding-right: 10px;
}
.lastNews {
  margin-bottom: 0;
}

.lastNews li {
  list-style: none;
  display: flex;
  align-items: center;
  line-height: 35px;
  justify-content: space-between;
  cursor: pointer;
}
.info-txt {
  width: 315px;
  white-space: nowrap;

  /*overflow: hidden;*/
  /*text-overflow: ellipsis;*/
  margin: 0;
}
.info-txt.wd420 {
  width: 255px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lastNews li .time {
  width: 130px;
  text-align: right;
}
.lastNews li .news {
  display: flex;
  align-items: center;
}

.lastNews li span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 14px;
  font-style: normal;
  border-radius: 3px;
  color: #fff;
  font-size: 12px;
  margin-right: 5px;
}

.lastNews li span.c-red {
  background: #c22a47;
}

.lastNews li span.c-blue {
  background: #3e7fc7;
}

.consultation {
  flex: 1;
}

.consultation + .consultation {
  margin-left: 20px;
}

.blue-bg .consultation {
  padding-left: 20px;
}

.blue-bg .consultation + .consultation {
  padding: 0 20px 0 5px;
}

.blue-bg .page-title span {
  color: #fff;
}

.blue-bg .page-title .line {
  background: none;
}

.blue-bg .title-box h3 {
  color: #fff;
}

.blue-bg .title-box a {
  color: #9ac4f9;
}

.blue-bg .lastNews li {
  color: #9ac4f9;
}

.enter-box {
  flex: 1;
  display: flex;
  text-align: center;
  justify-content: space-between;
  margin-left: 20px;
}

.enter-item {
  width: 132px;
  border: 1px solid #f1f4f6;
  cursor: pointer;
  padding-bottom: 10px;
}

.img-box {
  width: 80px;
  height: 75px;
  margin: 25px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.c-name {
  font-size: 18px;
  color: #000;
  line-height: 1;
  margin: 15px 0 10px 0;
}

.enter-item p {
  margin-bottom: 0;
  font-size: 16px;
  line-height: 1.2;
}

.service-list {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.service-list li {
  list-style: none;
  width: 374px;
  height: 114px;
  cursor: pointer;
}

.service-list li img {
  display: block;
}

.invest-btn {
  position: absolute;
  right: 0;
  top: -20px;
  height: 35px;
  line-height: 35px;
  width: 115px;
  text-align: center;
  background: #3390ef;
  color: #fff;
  border-radius: 5px 0 0 5px;
}

.invest-btn i {
  margin-right: 10px;
}
.third-title {
  display: flex;
  justify-content: space-between;
}
.list {
  width: 373px;
  line-height: 10px;
}
.listNews li {
  list-style: none;
  display: flex;
  align-items: center;
  line-height: 24px;
  width: 373px;
  justify-content: space-between;
  cursor: pointer;
}
.listNews li span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 14px;
  font-style: normal;
  border-radius: 3px;
  color: #fff;
  font-size: 12px;
  margin-right: 5px;
}

.listNews li span.c-red {
  background: #c22a47;
}

.listNews li span.c-blue {
  background: #3e7fc7;
}
.listNews li .new {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.wtime {
  width: 80px;
  white-space: nowrap;
  margin-left: -34px;
}
</style>
